import { createFileRoute } from "@tanstack/react-router";
import { SettingsView } from "@/features/settings/SettingsView";

/** ?setting=<message key of a setting's label> opens the page on that setting (settings search and the command palette). */
export const Route = createFileRoute("/_app/settings/$group/$page")({
  validateSearch: (search: { setting?: unknown }): { setting?: string } => (typeof search.setting === "string" && search.setting ? { setting: search.setting } : {}),
  component: Page,
});

function Page() {
  const { group, page } = Route.useParams();
  const { setting } = Route.useSearch();
  return <SettingsView group={group} page={page} setting={setting} />;
}
